/* Shared quote/devis math — used by the list, the detail panel and the PDF. */

export const linePrice = (p) => Number(p?.pivot?.price ?? p?.price ?? 0);
export const lineQty = (p) => Number(p?.pivot?.quantity ?? 0);
export const lineDiscount = (p) => Number(p?.pivot?.discount ?? 0);
export const lineDiscountType = (p) => p?.pivot?.discount_type || "percent";

export const lineGross = (p) => linePrice(p) * lineQty(p);

// per-line remise: percentage of the line, or a fixed MAD amount off the line
export const lineDiscountValue = (p) => {
  const gross = lineGross(p);
  const d = lineDiscount(p);
  return lineDiscountType(p) === "percent" ? (gross * d) / 100 : Math.min(d, gross);
};
export const lineNet = (p) => Math.max(0, lineGross(p) - lineDiscountValue(p));

export const quoteTotals = (order) => {
  const products = order?.products || [];
  const subtotal = products.reduce((s, p) => s + lineNet(p), 0);
  const dType = order?.discount_type || "amount";
  const dVal = Number(order?.discount || 0);
  const globalDiscount = dType === "percent" ? (subtotal * dVal) / 100 : Math.min(dVal, subtotal);
  const total = Math.max(0, subtotal - globalDiscount); // HT
  const vatRate = Number(order?.vat_rate || 0);
  const vatAmount = (total * vatRate) / 100;
  const totalTTC = total + vatAmount;
  return { subtotal, globalDiscount, total, vatRate, vatAmount, totalTTC };
};

export const formatMAD = (n) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "MAD" }).format(Number(n || 0));
